import styled from 'styled-components';

export const Wrapper = styled.div`
    color: #fff;
    .main-title {
        padding: 1rem 0rem 0rem 1rem;
        font-size: 24px;
        font-weight: bold;
    }
    a {
        text-decoration: none;
    }
    .warning-container {
        padding-top: 1rem;
        .warning-title {
            display: flex;
            align-items: center;
            .title {
                font-size: 18px;
                font-weight: bold;
            }
        }
        .flairnext{
            width :100%
        }
        .flair-content{
            display: flex;
            flex-direction: row;
            margin-bottom: 1rem;
            .anticon svg {
                margin-bottom: 30%;
            }
        }
        .flair_icon{
            height: 22px;
            margin: 1.5rem 0rem;
            margin-right:10px;
            width: 50px;
        }
        .warning-content {
            margin: 1rem 0rem;
            .flareunderline{
                text-decoration:underline
            }          
        }
        .btn-container {
            margin: 0.5rem 0rem;
            width: 100%;
            .ant-btn {
                height: 45px;
                width: 100%;
            }
        }
        .d-flex {
            display: flex;
            margin-top: 3.5rem;
        }
        .custom-info-circle {
                margin: 0px !important;
        }
    }
    .image-wrapper canvas {
        width: 100% !important;
        height: 100% !important;
    }
    .separator {
        margin: 0.5rem;
    }
    .container {
        padding: 0.5rem 1rem 1rem;
        margin-top: 0.5rem;
        /* color: #000; */
        .title {
            font-size: 16px;
            font-weight: bold;
        }
        .ant-input {
            width: 310px;
            border-radius: 0px;
            border: 2px solid #3A4FFF;
        }
        .input-wrapper {
            margin-top: 1rem;
            .main-domain {
                margin-bottom: 10px;
                color: #808083;
            }
            .space {
                margin-top: 1rem;
            }
            .box-container {
                // width: 350px;
                height: 25px;
                border: 1px solid #707070;
                display: flex;
                // justify-content: space-around;
                padding: 0px 8px;
                white-space: nowrap;

                .first-column {
                    width: 30%;
                }
                .second-column {
                    text-align: center;
                    width: 20%;
                }
                .third-column {
                    width: 50%;
                }
                .first-column,
                .second-column,
                .third-column {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
            .box-header {
                font-size: 12px;
                color: white;
                position: relative;
                top: 9px;
                left: 10px;
                z-index: 10;
                background-color: #29292C;
                width: 18%;
            }
            .box-square {
                width: 280px;
                // height: 100px;
                border: 1px solid #A8A8B1;
                .content-space {
                    padding: 1.5rem 0rem 1rem 1rem;
                }
                .bold-txt {
                    font-size: 15px;
                    font-weight: bold;
                }
            }
            .chk-btn-container {
                margin-top: 2rem;
                .ant-btn {
                    width: 190px;
                    height: 30px;
                }
                .space {
                    margin-left: 10px;
                }
                .anchor {
                    margin-top: 10px;
                }
            }
            .status {
                margin-top: 1rem;
                &.error-status {
                    .ant-badge-status-text {
                        color: #FF0000;
                    }
                }
                &.success-status {
                    .ant-badge-status-text {
                        color: #288500;
                    } 
                }
            }
            .ant-badge-status-dot {
                width: 10px;
                height: 10px;
            }
            .txt-label {
                margin-top: 1rem 0;
                color: #8F8F92;
            }
        }
        .ant-btn-primary[disabled] {
            color: #FFFFFF;
            background-color: #42454D; 
        }
        .ant-btn {
            width: 100%;
            height: 45px;
        }
        .btn-container {
            display: flex;
            justify-content: space-between;
            margin-top: 5rem;
        }
        .anchor a {
            color: #3A4FFF;
            text-decoration: underline;
        }
    }
    .secondary-container {
        padding-bottom: 1rem;
        text-align: center;
        canvas {
                    width: 100% !important;
                    height: 100% !important;
                }
        .contents-wrapper {
            padding: 3rem;
            .icon-wrapper {
                margin-bottom: 0.5rem;
                &.bill-icon {
                    img {
                        width: 80px;
                        height: 80px;
                    }
                }
                &.deploy-icon {
                    img {
                        width: 60px;
                        height: 60px;
                    }
                }
            }
            .content-1 {
                font-size: 16px;
                font-weight: bold;
            }
            .content-2 {
                margin-top: 0.5rem;
                font-size: 14px;
            }
        }
        .ant-btn {
            width: 100%;
            height: 45px;
        }
    }
    .payment-wrapper {
        .contents-wrapper {
            padding-top: 0rem;
        }
    }
    .init-container {
		margin: 0.5rem 0px;
        .ant-radio-group {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            .radio-text {
                font-size: 18px;
                font-weight: bold;
            }
            .box-wrapper{
                cursor:pointer;
                width: 48%;
                margin-bottom: 1rem;
                .imgcontainer{
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center;
                    height: 75px;
                }
                
                .ant-radio-wrapper {
                    margin-left: 0.8rem;
                    line-height:1
                }
            }
            .box-border {
                border: 1px solid #A8A8B1;
            }
            .small-text {
                margin-left: 1.5rem;
                margin-top: 0.5rem;
                color: #A8A8B1;
                font-size: 12px;
                white-space: normal;
            }
        }
        .upgrade-section {
            display: flex;
            justify-content: space-between;
            background-color: #F1F1F1;
            padding: 20px;
            margin-bottom: 20px;
            .btn-wrapper {
                display: flex;
                justify-content: center;
                align-items: center;
                .ant-btn {
                    background-color: #288500;
                    color: #FFFFFF;
                    border-color: #288500 !important;
                    height: 30px;
                }
            }
            .title-text {
                font-weight: bold;
            }
        }
        .disabled-text {
            opacity: 0.4;
        }
        .btn-wrapper {
            .ant-btn {
                width: 100%;
                height: 45px;
            }
        }
    }
    @media (max-width: 960px) {
        .init-container {
            .small-text {
                white-space: normal;
            }
        }
        .container {
            .input-wrapper {
                .box-container {
                    height: 100%;
                    flex-direction: column;
                    white-space: normal;
                }
                .box-square {
                    width: 100%;
                }
                .box-header {
                    width: 20%;
                }
            }
            .ant-input {
                width: 100%;
            }
            .btn-container {
                margin-top: 2rem;
            }
        }
    }
    @media (max-width:550px) {
        .container {
            .input-wrapper {
                .box-header {
                    width: 31%;
                }
            }
        }       
    }
    @media (max-width: 425px) {
        .init-container {
            .domain-container {
                flex-direction: column;
            }
            .ant-radio-group .box-wrapper {
                width: 100%;
            }
        }
        .container {
            .input-wrapper {
                .box-header {
                    width: 45%;
                }
            }
        }  
    }
    @media (max-width: 374px) {
        .warning-container {
            .flair-content {
                flex-direction: column;
            }
            .flair-icon-container {
                display: flex;
                justify-content: center;
                .flair_icon {
                    margin: 0;
                }
            }
        }
        .btn-container {
            flex-direction: column;
            button {
                width: 100%;
            }
        }
        .container {
            .input-wrapper {
                .box-header {
                    width: 48%;
                }
            }
        }   
    }
@media (max-width:280px) {
    .container {
            .input-wrapper {
                .box-header {
                    width: 65%;
                }
            }
        }       
}
`